import { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import {
  Home, FileText, Sparkles,
  ChevronLeft, Logo, Heart,
  Target, GraduationCap, Phone, Users
} from './Icons.jsx';
import { useAuth } from '../lib/auth.jsx';
import AuthModal from './AuthModal.jsx';
import Onboarding from './Onboarding.jsx';

const mainNav = [
  { to: '/', label: 'Home', icon: Home, end: true },
  { to: '/practice', label: 'Practice', icon: FileText },
  { to: '/plan', label: 'Plan', icon: Target },
  { to: '/apply', label: 'Apply', icon: GraduationCap },
  { to: '/medi', label: 'Ash · AI tutor', icon: Sparkles }
];

export default function Sidebar({ open, onClose }) {
  const { user, signOut, configured } = useAuth();
  const [authOpen, setAuthOpen] = useState(false);
  const [switchOpen, setSwitchOpen] = useState(false);
  return (
    <aside className={`sidebar ${open ? 'open' : ''}`}>
      <div className="sidebar-head">
        <div className="brand">
          <div className="brand-mark"><Logo width={52} height={52} /></div>
          <div className="brand-name">
            <span className="brand-main">Medi</span>
            <span className="brand-sub">powered by Medic Mind</span>
          </div>
        </div>
        <button className="sidebar-collapse" aria-label="Collapse" onClick={onClose}>
          <ChevronLeft />
        </button>
      </div>

      <button
        onClick={() => window.__mmOpenSearch?.()}
        style={{
          margin: '0 12px 12px', padding: '8px 10px', display: 'flex', alignItems: 'center', gap: 8,
          background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: 10, cursor: 'pointer', color: 'rgba(255,255,255,0.7)', fontSize: 13,
          fontFamily: 'inherit', textAlign: 'left'
        }}
        aria-label="Search"
      >
        <span style={{ fontSize: 14 }}>⌕</span>
        <span style={{ flex: 1 }}>Search…</span>
        <kbd style={{ padding: '1px 5px', borderRadius: 3, background: 'rgba(255,255,255,0.1)', fontSize: 10.5, fontFamily: 'monospace' }}>⌘K</kbd>
      </button>

      <nav className="nav">
        {mainNav.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={onClose}
          >
            <span className="icon"><item.icon /></span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-cta">
        <div className="sidebar-cta-kicker">
          <Phone width="14" height="14" />
          <span>Free 15-min call</span>
        </div>
        <div className="sidebar-cta-title">Talk to a Medic Mind tutor</div>
        <p className="sidebar-cta-body">Honest read on your plan, schools and score gap.</p>
        <a className="sidebar-cta-btn" href="https://www.medicmind.co.uk/contact-us/" target="_blank" rel="noreferrer">Book call</a>
      </div>

      <div className="sidebar-footer">
        {configured && (
          user ? (
            <div style={{ padding: '8px 12px', fontSize: 12.5, color: 'rgba(255,255,255,0.7)' }}>
              <div style={{ fontWeight: 600, color: '#fff', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user.email}</div>
              <div style={{ display: 'flex', gap: 12, marginTop: 4 }}>
                <button onClick={() => setSwitchOpen(true)} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.6)', fontSize: 12, fontWeight: 600, cursor: 'pointer', padding: 0 }}>Switch role</button>
                <button onClick={signOut} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.6)', fontSize: 12, fontWeight: 600, cursor: 'pointer', padding: 0 }}>Sign out</button>
              </div>
            </div>
          ) : (
            <>
              <Link to="/signup" className="nav-item" onClick={onClose} style={{ textDecoration: 'none' }}>
                <span className="icon"><Sparkles width="18" height="18" /></span>
                <span>Sign up free</span>
              </Link>
              <button onClick={() => setAuthOpen(true)} className="nav-item" style={{ background: 'none', border: 'none', textAlign: 'left', width: '100%', cursor: 'pointer', fontFamily: 'inherit', opacity: 0.85 }}>
                <span className="icon"><Sparkles width="18" height="18" /></span>
                <span>Sign in</span>
              </button>
            </>
          )
        )}
        {user && (user.role === 'admin' || user.role === 'superadmin') && (
          <NavLink to="/admin" className="nav-item" onClick={onClose}>
            <span className="icon"><Users width="18" height="18" /></span>
            <span>Admin dashboard</span>
          </NavLink>
        )}
        <NavLink to="/parents" className="nav-item" onClick={onClose}>
          <span className="icon"><Heart width="18" height="18" /></span>
          <span>Parents portal →</span>
        </NavLink>
        <NavLink to="/teachers" className="nav-item" onClick={onClose}>
          <span className="icon"><GraduationCap width="18" height="18" /></span>
          <span>Teachers portal →</span>
        </NavLink>
        <NavLink to="/about" className="nav-item" onClick={onClose}>
          <span className="icon"><Users width="18" height="18" /></span>
          <span>Meet the founder</span>
        </NavLink>
      </div>
      <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} />
      <Onboarding open={switchOpen} onClose={() => setSwitchOpen(false)} />
    </aside>
  );
}
